import * as marietta from '../..';
import { SVGSprite } from '../flash/display';
import { Stage } from '../model';
import {
  PINTEXT_PIN_WIDTH, PINTEXT_PIN_HEIGHT
} from '../Constants';
import { PinText } from '../item';
import * as THREE from 'three';

/**
 * テキストアイテムのアイテムコントローラー
 */
export default class ItemControllerPinText {
  target: marietta.webcad.item.MonicaObject;

  allBox: marietta.webcad.control.parts.BoundingBox;

  rotator: marietta.webcad.control.parts.ControlRotator;

  startPoint: marietta.core.Point;

  x: number;

  y: number;

  rotation: number;

  width: number;

  height: number;

  dragStartPoint: marietta.core.Point;

  tarLayer: marietta.webcad.layer.FloorShitaeLayer;

  public spt: SVGSprite;

  public emptySpt: SVGSprite;

  padding: number;

  btnDelete: marietta.webcad.control.parts.ButtonGarbage;

  btnTextSetting: marietta.webcad.control.parts.ButtonTextSetting;

  btnDragger: marietta.webcad.control.parts.DraggerMobile;
  /**
   * コンストラクタ
   */
  constructor(_target: marietta.webcad.item.MonicaObject) {
    // ターゲット
    this.target = _target;
    this.initMe();
  }

  /**
   * 初期化関数
   * viewObjの作成
   */
  initMe() {
    // 作成する階
    this.tarLayer = marietta.webcad.WebCADGlobal.layerGroup.getFloorLayer(this.target.itemInfo.floor) as marietta.webcad.layer.FloorShitaeLayer;
    // 形状の生成
    const viewObj = document.createElementNS('http://www.w3.org/2000/svg', 'g');
    viewObj.id = 'controller';
    // 全体のボックス
    this.allBox = new marietta.webcad.control.parts.BoundingBox(viewObj);

    // モバイル
    const ua = marietta.webcad.WebCADGlobal.userAgentManager;
    if (ua.isMobile || ua.isTablet) {
      // 削除ボタン
      this.btnDelete = new marietta.webcad.control.parts.ButtonGarbage(viewObj, this.target);
      // 反転ボタン
      this.btnTextSetting = new marietta.webcad.control.parts.ButtonTextSetting(viewObj, this.target);
      // 移動軸
      this.btnDragger = new marietta.webcad.control.parts.DraggerMobile(viewObj, this.target);
      this.btnDragger.dragFunc = this.onMoveDragger;
      this.btnDragger.dragEndFunc = this.onMoveEndDragger;
    }

    if (this.target.itemInfo.lock) {
      this.hideToolTips();
    } else {
      this.showToolTips();
    }

    this.tarLayer.viewObj.appendChild(viewObj);
    this.spt = new SVGSprite(viewObj);
    this.padding = this.target.itemInfo.font_size / 3;

    // ターゲットに合わせてサイズ変更
    this.resizeToTarget();
  }

  /**
   * ターゲットに合わせて各種パーツリサイズ
   */
  resizeToTarget() {
    // 位置合わせ
    this.syncMeToTarget();
    this.target.rotate(0);
    // SVGSpriteのwidth/heightに書き換え
    const bounding = this.target.viewObj.getBoundingClientRect();
    const width: number = bounding.width / marietta.webcad.WebCADGlobal.scaleSize;
    const height: number = bounding.height / marietta.webcad.WebCADGlobal.scaleSize;
    this.updateIconButtons();
    // 全体Box
    this.allBox.resize({ width, height });
    if ((this.target as PinText).isTextHide) {
      this.allBox.move(0, 0);
    } else {
      this.allBox.move(width / 2 - PINTEXT_PIN_WIDTH, height / 2 - PINTEXT_PIN_HEIGHT / 2);
    }
    this.updateTransforms();
  }

  /**
   * ターゲットにシンクロする
   * ※アイテムのドラッグ時に呼び出される
   */
  syncMeToTarget() {
    this.x = this.target.itemInfo.x;
    this.y = this.target.itemInfo.y;
    this.rotation = this.target.itemInfo.rotation;
    this.updateTransforms();
  }

  /**
   * Translateのアップデート
   */
  updateTransforms() {
    this.spt.x = this.x;
    this.spt.y = this.y;
    this.spt.rotation = 0;
    this.spt.update();
  }

  /**
   * コントロールピッカーが移動された
   */
  onMoveDragger = () => {
    // ロックされている場合は、行わない
    if (!this.target.isCapableOfMove()) return;
    // 開始時のアイテム場所保持
    if (this.dragStartPoint === undefined || this.dragStartPoint === null) {
      if (this.emptySpt === undefined) {
        // テキストが表示中なら非表示にする
        if (!(this.target as PinText).isTextHide) {
          (this.target as PinText).onPinMouseUpMe();
        }
        /*
          本来はtarget.sptのmouseX/mouseYで取得できるが、
          拡縮するとアイテムの位置が変わるため、正しいドラッグ位置が取れなくなる。
          そのためタグを持たないemptySptを別途作って、mouseX/mouseYの値を
          取得している。
        */
        this.emptySpt = new SVGSprite(null, true);
        this.emptySpt.setEmptyParam(this.btnDragger.spt);
        this.target.spt.parent.addChild(this.emptySpt);
      }

      // ドラッグの開始位置
      this.dragStartPoint = new marietta.core.Point(this.target.spt.mouseX * this.target.spt.scaleX, this.target.spt.mouseY * this.target.spt.scaleY);
    }
    const newPoint: marietta.core.Point = new marietta.core.Point(marietta.webcad.WebCADGlobal.layerGroup.spt.mouseX, marietta.webcad.WebCADGlobal.layerGroup.spt.mouseY);
    // ターゲットの移動
    this.target.move(newPoint.x, newPoint.y);
    // ターゲットに吸着
    this.syncMeToTarget();
  }

  /**
   * コントロールピッカーのドラッグ終了
   */
  onMoveEndDragger = () => {
    this.dragStartPoint = null;
    if (this.emptySpt && this.emptySpt.parent) {
      this.emptySpt.parent.removeChild(this.emptySpt);
      this.emptySpt = null;
    }
    // マウスアップの挙動
    marietta.webcad.WebCADGlobal.itemManager.currentItem = this.target;
  }

  /**
   * アイコンボタンの更新
   */
  updateIconButtons() {
    if (!this.target?.viewObj) return;
    const isHide = (this.target as PinText).isTextHide
    const bounding = this.target.viewObj.getBoundingClientRect();
    const ua = marietta.webcad.WebCADGlobal.userAgentManager;
    /** ピンの中心点の差異 */
    const pinDiff = 10;
    /** 配置間隔の調整用 */
    const pinSpace = 25;
    if (ua.isMobile || ua.isTablet) {
      // 削除ボタン
      this.btnDelete.move(bounding.width + pinSpace - (isHide ? 0 : pinDiff), bounding.height / 2);
      // 編集ボタン
      this.btnTextSetting.move(-pinSpace * 2 - (isHide ? 0 : pinDiff), bounding.height / 2);
      // 移動軸
      this.btnDragger.move(bounding.width / 2 - (isHide ? pinDiff : pinSpace), bounding.height + pinSpace);
    }
  }

  hideToolTips() {
    const ua = marietta.webcad.WebCADGlobal.userAgentManager;
    if (ua.isMobile || ua.isTablet) {
      this.btnDelete.hide();
      this.btnDragger.hide();
      this.btnTextSetting.hide();
    }
  }

  showToolTips() {
    const ua = marietta.webcad.WebCADGlobal.userAgentManager;
    if (ua.isMobile || ua.isTablet) {
      this.btnDelete.show();
      this.btnDragger.show();
      this.btnTextSetting.show();
    }
  }

  /**
   * 回転の開始
   */
  protected rotateStart = () => {
    this.x = this.target.itemInfo.x;
    this.y = this.target.itemInfo.y;
    this.updateTransforms();
    const { width, height } = this.target.itemInfo;
    this.allBox.move(-width / 2, -height / 2);
  };

  /**
   * 回転する
   * @param e
   */
  protected rotate = (e: MouseEvent) => {
    const firstPoint: marietta.core.Point = new marietta.core.Point(this.target.itemInfo.x, this.target.itemInfo.y);
    const newPoint: marietta.core.Point = marietta.webcad.util.WebCADUtil.convertToLocalPoint(e);
    const secondPoint: marietta.core.Point = new marietta.core.Point(newPoint.x, newPoint.y);
    // レイヤーのスケーリング分を考慮
    const root: SVGSprite = marietta.webcad.WebCADGlobal.layerGroup.spt;
    secondPoint.x -= Stage.offsetX - marietta.webcad.WebCADGlobal.OUTERFRAME_LEFT_FRAME_WIDTH;
    secondPoint.y -= Stage.offsetY - marietta.webcad.WebCADGlobal.OUTERFRAME_HEADER_HEIGHT;
    secondPoint.x /= root.scaleX;
    secondPoint.y /= root.scaleY;
    // 角度
    const radian: number = Math.atan2(firstPoint.x - secondPoint.x, firstPoint.y - secondPoint.y);
    let angle: number = -radian / (Math.PI / 180) + 360;
    const unit: number = 45;
    if (angle % unit > 5 && angle % unit < unit - 5) {
      this.rotator.showAssist(false);
    } else {
      this.rotator.showAssist(true);
      angle = Math.round(angle / unit) * unit;
    }
    this.rotation = angle;
    this.updateTransforms();
    // ターゲットを回転
    this.target.rotate(angle);
    if (this.emptySpt) {
      this.emptySpt.setEmptyParam(this.target.spt);
    }

    // 行列がある場合
    if (this.target.itemInfo.transformMatrix) {
      this.setTransformMatrix(angle);
    }
  };

  private setTransformMatrix(angle: number) {
    const convertAngle = (inputAngle: number): number => {
      return (inputAngle <= 180) ? 180 - inputAngle : 540 - inputAngle;
    }

    const matrix = new THREE.Matrix4();
    matrix.fromArray(this.target.itemInfo.transformMatrix);

    const position = new THREE.Vector3();
    const quaternion = new THREE.Quaternion();
    const scale = new THREE.Vector3();
    matrix.decompose(position, quaternion, scale);

    const euler = new THREE.Euler().setFromQuaternion(quaternion, 'YXZ');
    euler.y = THREE.MathUtils.degToRad(convertAngle(angle % 360));
    quaternion.setFromEuler(euler);

    matrix.compose(position, quaternion, scale);

    this.target.itemInfo.transformMatrix = matrix.toArray();
  }

}
